import { IApiSuccessWrapper } from '$/types'
import { apiSlice } from 'app/services/api'

export enum RiskThresholdLevelCode {
  LowRisk = 'LowRisk',
  MediumRisk = 'MediumRisk',
  HighRisk = 'HighRisk',
  MediumHighRisk = 'MediumHighRisk',
  MediumLowRisk = 'MediumLowRisk'
}

export enum RiskThresholdLevelName {
  LowRisk = 'Low',
  MediumRisk = 'Medium',
  HighRisk = 'High',
  MediumHighRisk = 'Medium - High',
  MediumLowRisk = 'Medium - Low'
}

export interface IAcceptanceCategory {
  id?: number
  code: RiskThresholdLevelCode
  name: string
  colour: string
  minValue: number
  maxValue: number
  minDensityValue: number
  maxDensityValue: number
  canBeDeleted: boolean
  enabled: boolean
}

export interface UpdateAcceptanceCategoriesPayload {
  categories: Array<{
    code: RiskThresholdLevelCode
    minValue: number
    maxValue: number
    minDensityValue: number
    maxDensityValue: number
  }>
}

export const acceptanceCategoriesApi = apiSlice
  .enhanceEndpoints({ addTagTypes: ['AcceptanceCategories'] })
  .injectEndpoints({
    endpoints: (build) => ({
      getAcceptanceCategories: build.query<IAcceptanceCategory[], void>({
        query: () => '/acceptanceCategories',
        transformResponse: (res: IApiSuccessWrapper<IAcceptanceCategory[]>) => {
          // Pre-sort Risk Thresholds Coloring list (AKA AcceptanceCategory)
          const order: RiskThresholdLevelCode[] = [
            RiskThresholdLevelCode.LowRisk,
            RiskThresholdLevelCode.MediumLowRisk,
            RiskThresholdLevelCode.MediumRisk,
            RiskThresholdLevelCode.MediumHighRisk,
            RiskThresholdLevelCode.HighRisk
          ]

          const sortedRes = [...res.result].sort((a, b) => {
            return order.indexOf(a.code) - order.indexOf(b.code)
          })

          return sortedRes.filter((threshold) => threshold.enabled)
        },
        providesTags: ['AcceptanceCategories']
      }),
      updateAcceptanceCategories: build.mutation<
        IAcceptanceCategory[],
        UpdateAcceptanceCategoriesPayload
      >({
        query: (payload) => ({
          url: '/acceptanceCategories',
          method: 'POST',
          body: payload
        }),
        transformResponse: (res: IApiSuccessWrapper<IAcceptanceCategory[]>) =>
          res.result,
        invalidatesTags: ['AcceptanceCategories']
      })
    })
  })

export const {
  useGetAcceptanceCategoriesQuery,
  useUpdateAcceptanceCategoriesMutation
} = acceptanceCategoriesApi
